import { render } from "./ButtonCTA.vue?vue&type=template&id=527919fd&scoped=true"
import script from "./ButtonCTA.vue?vue&type=script&lang=js"
export * from "./ButtonCTA.vue?vue&type=script&lang=js"

import "./ButtonCTA.vue?vue&type=style&index=0&id=527919fd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527919fd"]])

export default __exports__